import { TypedAction } from '@ngrx/store/src/models';
import { LoyaltyResponse } from '@symphony-solo/shared/http/src';
import { TokenResult } from '../models';
import { AuthenticationActionTypes } from '../+state';

export abstract class BaseHandler {
  protected nextHandler: BaseHandler;

  public addNext(handler: BaseHandler): void {
    this.nextHandler = handler;
  }

  public abstract handle(
    response: LoyaltyResponse<TokenResult>
  ): TypedAction<AuthenticationActionTypes>;
}
